import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import SchemaOrg from '@/components/feature/SchemaOrg';
import { testimonials } from '@/mocks/comics';

export default function AboutPage() {
  const location = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'instant' });
  }, [location.pathname]);

  return (
    <>
      <SchemaOrg
        type="Organization"
        data={{
          name: '妖精动漫',
          url: 'https://yaojingdongman.com',
          description: '妖精动漫精选无删减韩国漫画，下拉式阅读模式搭配免费韩漫大全，资源丰富、界面友好，操作简单便捷，让您轻松找到心仪的韩漫作品。',
          contactPoint: {
            '@type': 'ContactPoint',
            email: 'contact@yaojingdongman.com',
            contactType: 'customer service',
          },
          address: {
            '@type': 'PostalAddress',
            addressLocality: '首尔',
            addressRegion: '首尔特别市',
            addressCountry: 'KR',
          },
        }}
      />
      <SchemaOrg
        type="WebPage"
        data={{
          name: '关于我们 - 妖精动漫',
          description: '了解妖精动漫的品牌故事、核心价值观与联系方式。韩国漫画无删减下拉式阅读平台，免费韩漫大全。',
          url: 'https://yaojingdongman.com/about',
        }}
      />
      <SchemaOrg
        type="BreadcrumbList"
        data={{
          itemListElement: [
            {
              '@type': 'ListItem',
              position: 1,
              name: '首页',
              item: 'https://yaojingdongman.com',
            },
            {
              '@type': 'ListItem',
              position: 2,
              name: '关于我们',
            },
          ],
        }}
      />

      <div className="min-h-screen bg-background-50">
        <Navbar />
        <main className="pt-20">
          <div className="px-4 md:px-6">
            <Breadcrumb items={[{ label: '首页', href: '/' }, { label: '关于我们' }]} />

            <section className="max-w-4xl mx-auto mb-16">
              <div className="text-center mb-10">
                <h1 className="text-3xl md:text-4xl font-bold font-heading text-foreground-950 mb-3">
                  关于妖精动漫
                </h1>
                <p className="text-sm text-foreground-500 max-w-2xl mx-auto">
                  致力于为韩漫爱好者打造优质阅读体验的平台
                </p>
              </div>

              <div className="relative rounded-2xl overflow-hidden mb-10 h-[280px] md:h-[360px]">
                <img
                  src="https://readdy.ai/api/search-image?query=A%20warm%20and%20artistic%20illustration%20of%20a%20cozy%20reading%20space%20with%20bookshelves%20filled%20with%20comics%2C%20soft%20warm%20lighting%2C%20modern%20minimalist%20interior%2C%20comfortable%20reading%20nook%2C%20Korean%20style%20aesthetic&width=1200&height=500&seq=about-hero-01&orientation=landscape"
                  alt="妖精动漫阅读空间"
                  className="w-full h-full object-cover"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/40 to-transparent" />
                <div className="absolute bottom-6 left-6 md:left-10">
                  <span className="text-white/80 text-sm">我们的故事</span>
                  <h2 className="text-2xl md:text-3xl font-bold font-heading text-white mt-1">
                    让更多人爱上韩国漫画
                  </h2>
                </div>
              </div>

              <div className="space-y-8 text-sm leading-relaxed text-foreground-700">
                <div>
                  <h3 className="text-lg font-bold font-heading text-foreground-900 mb-3">
                    品牌故事
                  </h3>
                  <p>
                    妖精动漫诞生于2020年，由一群热爱韩国漫画的年轻人共同创立。我们的初衷很简单——让更多中文读者能够轻松接触到优质的韩国漫画作品。在韩国漫画日益风靡全球的浪潮中，我们深感中文世界缺乏一个专注、全面且体验优良的韩漫阅读平台。于是，妖精动漫应运而生。
                  </p>
                </div>

                <div>
                  <h3 className="text-lg font-bold font-heading text-foreground-900 mb-3">
                    我们的使命
                  </h3>
                  <p>
                    妖精动漫的使命是成为中文世界最值得信赖的韩国漫画平台。我们坚持提供<strong>无删减</strong>的完整版漫画内容，尊重每一位创作者的劳动成果和艺术表达。同时，我们采用了创新的<strong>下拉式阅读</strong>模式，让读者能够以最自然流畅的方式沉浸于漫画世界，告别繁琐的翻页操作。
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-5 mt-8">
                  <div className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-shield-check-line text-xl text-primary-500"></i>
                    </div>
                    <h4 className="text-sm font-bold font-heading text-foreground-900 mb-2">
                      全部无删减
                    </h4>
                    <p className="text-xs text-foreground-500">
                      所有韩国漫画均为完整原版，绝不删减修改任何内容，尊重作者创作
                    </p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-accent-100">
                      <i className="ri-scroll-to-bottom-line text-xl text-accent-500"></i>
                    </div>
                    <h4 className="text-sm font-bold font-heading text-foreground-900 mb-2">
                      下拉式阅读
                    </h4>
                    <p className="text-xs text-foreground-500">
                      创新的下拉式阅读模式，流畅自然的浏览体验，告别翻页的繁琐操作
                    </p>
                  </div>
                  <div className="bg-background-100 rounded-xl p-6 text-center">
                    <div className="w-12 h-12 mx-auto mb-3 flex items-center justify-center rounded-full bg-secondary-100">
                      <i className="ri-community-line text-xl text-secondary-500"></i>
                    </div>
                    <h4 className="text-sm font-bold font-heading text-foreground-900 mb-2">
                      免费韩漫大全
                    </h4>
                    <p className="text-xs text-foreground-500">
                      2000+部韩国漫画免费阅读，涵盖恋爱、奇幻、动作等丰富分类
                    </p>
                  </div>
                </div>

                <div>
                  <h3 className="text-lg font-bold font-heading text-foreground-900 mb-3">
                    核心优势
                  </h3>
                  <ul className="space-y-3">
                    <li className="flex gap-3">
                      <i className="ri-checkbox-circle-line text-accent-500 flex-shrink-0 mt-0.5"></i>
                      <span><strong>内容丰富：</strong>收录超过2000部韩国漫画，涵盖恋爱、奇幻、动作、悬疑、搞笑、剧情、恐怖等多个分类，满足不同读者的口味需求。</span>
                    </li>
                    <li className="flex gap-3">
                      <i className="ri-checkbox-circle-line text-accent-500 flex-shrink-0 mt-0.5"></i>
                      <span><strong>更新及时：</strong>与韩国原作同步更新，让您第一时间阅读到最新章节，不错过任何精彩内容。</span>
                    </li>
                    <li className="flex gap-3">
                      <i className="ri-checkbox-circle-line text-accent-500 flex-shrink-0 mt-0.5"></i>
                      <span><strong>界面友好：</strong>简洁清晰的操作界面，智能的分类和搜索系统，让您轻松找到心仪的韩漫作品。</span>
                    </li>
                    <li className="flex gap-3">
                      <i className="ri-checkbox-circle-line text-accent-500 flex-shrink-0 mt-0.5"></i>
                      <span><strong>多端适配：</strong>完美支持手机、平板和电脑等多种设备，随时随地享受阅读乐趣。</span>
                    </li>
                  </ul>
                </div>
              </div>
            </section>

            <section className="max-w-4xl mx-auto mb-16">
              <div className="text-center mb-8">
                <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                  读者评价
                </h2>
                <p className="text-sm text-foreground-500">
                  来自真实读者的心声
                </p>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-3 gap-5">
                {testimonials.map((t) => (
                  <div key={t.name} className="bg-background-100 rounded-xl p-6">
                    <div className="flex items-center gap-1 mb-3">
                      {Array.from({ length: t.rating }).map((_, i) => (
                        <i key={i} className="ri-star-fill text-accent-500 text-sm"></i>
                      ))}
                    </div>
                    <p className="text-sm text-foreground-700 leading-relaxed mb-4">
                      "{t.comment}"
                    </p>
                    <div className="flex items-center gap-3">
                      <img
                        src={t.avatar}
                        alt={t.name}
                        className="w-10 h-10 rounded-full object-cover"
                      />
                      <span className="text-sm font-medium text-foreground-900">{t.name}</span>
                    </div>
                  </div>
                ))}
              </div>
            </section>

            <section className="max-w-4xl mx-auto mb-16">
              <div className="bg-background-100 rounded-2xl p-8 md:p-10">
                <div className="text-center mb-8">
                  <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
                    联系我们
                  </h2>
                  <p className="text-sm text-foreground-500">
                    如有任何问题或建议，欢迎随时联系我们
                  </p>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div className="flex items-start gap-4 p-4 rounded-xl">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-mail-line text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-bold font-heading text-foreground-900 mb-1">电子邮箱</h4>
                      <p className="text-sm text-foreground-600">contact@yaojingdongman.com</p>
                      <p className="text-xs text-foreground-400 mt-0.5">一般咨询与合作</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 rounded-xl">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-accent-100">
                      <i className="ri-map-pin-line text-accent-500"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-bold font-heading text-foreground-900 mb-1">办公地址</h4>
                      <p className="text-sm text-foreground-600">韩国首尔特别市江南区驿三路 123号</p>
                      <p className="text-xs text-foreground-400 mt-0.5">妖精动漫总部</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 rounded-xl">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-secondary-100">
                      <i className="ri-time-line text-secondary-500"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-bold font-heading text-foreground-900 mb-1">工作时间</h4>
                      <p className="text-sm text-foreground-600">周一至周五 09:00 - 18:00 (KST)</p>
                      <p className="text-xs text-foreground-400 mt-0.5">周末及节假日休息</p>
                    </div>
                  </div>

                  <div className="flex items-start gap-4 p-4 rounded-xl">
                    <div className="w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full bg-primary-100">
                      <i className="ri-phone-line text-primary-500"></i>
                    </div>
                    <div>
                      <h4 className="text-sm font-bold font-heading text-foreground-900 mb-1">客服热线</h4>
                      <p className="text-sm text-foreground-600">+82-2-1234-5678</p>
                      <p className="text-xs text-foreground-400 mt-0.5">韩国标准时间工作日 09:00-18:00</p>
                    </div>
                  </div>
                </div>
              </div>
            </section>
          </div>
        </main>
        <Footer />
      </div>
    </>
  );
}